import browserDetect from 'brandhub-embxp-frontend/src/common/js/browserdetect/browserdetect';

// required to fix bootstrap 4 accordion on IE11
if (browserDetect.isIE11) {
  // fix Object.keys
  Object.keys = function (obj) {
    var keys = [];

    for (var i in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, i)) {
        keys.push(i);
      }
    }

    return keys;
  };
}



// WEBPACK FOOTER //
// ./src/common/js/objectkeysfix/objectkeysfix.js